import { Injectable, effect, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly storageKey = 'mis-theme';
  private readonly _darkMode: WritableSignal<boolean> = signal(false);
  readonly darkMode = this._darkMode.asReadonly();

  constructor() {
    const saved = localStorage.getItem(this.storageKey);
    let initialDark = false;
    
    if (saved) {
      initialDark = saved === 'dark';
    } else {
      initialDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    
    this._darkMode.set(initialDark);
    this.applyTheme(initialDark);

    effect(() => {
      const isDark = this._darkMode();
      this.applyTheme(isDark);
    });
  }

  private applyTheme(isDark: boolean) {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
      localStorage.setItem(this.storageKey, isDark ? 'dark' : 'light');
  }

  toggle() {
    const current = this._darkMode();
    const newValue = !current;
    console.log('ThemeService.toggle() - changing from', current, 'to', newValue);
    this._darkMode.set(newValue);
  }
}


